module.exports = __webpack_public_path__ + "img/noodle.751a74b0.png";